/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepancyResponse } from '../../models/article-discrepancy-response';
import { KeyType } from '../../models/key-type';

export interface GetArticleDiscrepancy$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  discrepancyKey: KeyType;
  articleKey: KeyType;
}

export function getArticleDiscrepancy(http: HttpClient, rootUrl: string, params: GetArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepancyResponse>> {
  const rb = new RequestBuilder(rootUrl, getArticleDiscrepancy.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('discrepancyKey', params.discrepancyKey, {});
    rb.path('articleKey', params.articleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleDiscrepancyResponse>;
    })
  );
}

getArticleDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies/{discrepancyKey}';
